import { useQuery } from '@tanstack/react-query';
import { getOnboardingAnswers } from 'shared/services/local-storage/onboarding';

export const queryKey = 'onboarding-answers';

export const useOnboardingAnswersQuery = () =>
  useQuery({
    queryKey: [queryKey],
    queryFn: () => getOnboardingAnswers(),
  });
